<script setup>
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {ref} from "vue";
import {ElLoading} from 'element-plus'
//表格数据
let expressionList = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(20)
//axios请求
import {inject} from 'vue'

const $axios = inject('$axios')

const species = ref('')
const goSearch = ref('')

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function searchExpression() {
  expressionList.value = []
  goSearch.value = ''
  if (species.value != '') {
    const loadingInstance = ElLoading.service({fullscreen: true, text: 'Loading', background: 'rgba(0, 0, 0, 0.7)',lock:true})
    $axios.get('http://bioinfo-gdut.com:8000/api/show_' + species.value).then((resp) => {
      if (JSON.parse(JSON.stringify(resp.data)).respCode === '000000') {
        expressionList.value = JSON.parse(JSON.stringify(resp.data))['list']
        loadingInstance.close()
      }
      goSearch.value = species.value
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>
<template>
  <div>
    <navbar/>
    <main class="profile-page">
      <section class="relative block h-500-px">
        <div
            class="absolute top-0 w-full h-full bg-center bg-cover"
            style="
            background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
          "
        >
          <span
              id="blackOverlay"
              class="w-full h-full absolute opacity-50 bg-black"
          ></span>
        </div>
        <div
            class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
            style="transform: translateZ(0);"
        >
          <svg
              class="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
          >
            <polygon
                class="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </section>
      <section class="relative py-16 bg-blueGray-200">
        <div class="container mx-auto px-4">
          <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64"
          >
            <div class="px-6">
              <div class="text-center mt-12 d-flex flex-column">
                <h3
                    class="text-4xl font-semibold leading-normal mb-4 text-blueGray-700"
                >
                  Gene Expression
                </h3>
                <div class="d-flex flex-row justify-content-center">
                  <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="species"
                          style="width: 28%; color: #ccc;">
                    <option value="" disabled selected hidden>Select your specie</option>
                    <option value="Cb3" style="color: black;">Cinnamomum burmannii</option>
                    <option value="Cca4" style="color: black;">Cinnamomum camphora</option>
                    <option value="Cch3" style="color: black;">Cinnamomum chago</option>
                    <option value="Ck8" style="color: black;">Cinnamomum kanehirae</option>
                    <option value="Cp9" style="color: black;">Cinnamomum parthenoxylon</option>
                    <option value="Ct4" style="color: black;">Cinnamomum tenuipile</option>
                    <option value="Cv4" style="color: black;">Cinnamomum verum</option>
                    <option value="Ln7" style="color: black;">Laurus nobilis</option>
                    <option value="Lg2" style="color: black;">Lindera glauca</option>
                    <option value="Lc9" style="color: black;">Litsea cubeba</option>
                  </select>
                  <button
                      class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      @click="searchExpression">
                    Search
                  </button>
                </div>
                <div id="Cb3_tablePagination" class="row justify-content-center" v-show="goSearch=='Cb3'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed;font-size:18px">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">BFT</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">LBT</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">HBT</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].bft }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].lbt }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].hbt }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Ck8_tablePagination" class="row justify-content-center" v-show="goSearch=='Ck8'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Stems</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Leaves of buds</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Old leaves</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Buds</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Flower</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Fruits</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Flower of buds</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Young leaves</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_905_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_906_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_908_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_909_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_910_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_911_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_917_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_918_rsem_genes_results }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Cp9_tablePagination" class="row justify-content-center" v-show="goSearch=='Cp9'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 5%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Linalool-type1</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Linalool-type2</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Linalool-type3</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Camphor-type1</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Camphor-type2</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Camphor-type3</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Eucalyptol-type1</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Eucalyptol-type2</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Eucalyptol-type3</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_7748_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7749_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7750_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_7751_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_7752_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7753_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7754_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7755_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_7756_rsem_genes_results }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Ct4_tablePagination" class="row justify-content-center" v-show="goSearch=='Ct4'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate1</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate2</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate3</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower lesf stem bud bark
                          flower_bud
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_3929_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_3930_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_3931_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_4015_rsem_genes_results
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Cv4_tablePagination" class="row justify-content-center" v-show="goSearch=='Cv4'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate1</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate2</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower bud replicate3</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Biosexual flower lesf stem bud bark
                          flower_bud
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_3926_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_3927_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_3928_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_4016_rsem_genes_results
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Cca4_tablePagination" class="row justify-content-center" v-show="goSearch=='Cca4'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 18%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 18%" class="pe-0 ps-0">Borneol-type1</th>
                        <th scope="col" style="width: 18%" class="pe-0 ps-0">Borneol-type2</th>
                        <th scope="col" style="width: 18%" class="pe-0 ps-0">Linalool-type1</th>
                        <th scope="col" style="width: 18%" class="pe-0 ps-0">Linalool-type2</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_154_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_155_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_156_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_157_rsem_genes_results
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Cch3_tablePagination" class="row justify-content-center" v-show="goSearch=='Cch3'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Sample1</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Sample2</th>
                        <th scope="col" style="width: 20%" class="pe-0 ps-0">Sample3</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_337_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_339_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_423_rsem_genes_results }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Lc9_tablePagination" class="row justify-content-center" v-show="goSearch=='Lc9'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 6%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 6%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Leaf6_7</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Leaf5_9</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Leaf3_31</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Stem6_7</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Stem5_9</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Stem3_31</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Root6_7</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Root5_9</th>
                        <th scope="col" style="width: 11%" class="pe-0 ps-0">Root3_31</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_4022_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_4023_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_4024_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_4025_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_4027_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_4028_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_4029_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_4030_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_4031_rsem_genes_results }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Lg2_tablePagination" class="row justify-content-center" v-show="goSearch=='Lg2'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 10%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 40%" class="pe-0 ps-0">Female foral bud</th>
                        <th scope="col" style="width: 40%" class="pe-0 ps-0">Male foral bud</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_446_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_449_rsem_genes_results }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>
                <div id="Ln7_tablePagination" class="row justify-content-center" v-show="goSearch=='Ln7'">
                  <div class="col-12">
                    <table class="table table-striped table-sm align-middle mt-4"
                           style="text-align: center;table-layout:fixed">
                      <thead>
                      <tr>
                        <th scope="col" style="width: 8%" class="pe-0 ps-0">#</th>
                        <th scope="col" style="width: 8%" class="pe-0 ps-0">Gene</th>
                        <th scope="col" style="width: 12%" class="pe-0 ps-0">Male flower bud1</th>
                        <th scope="col" style="width: 12%" class="pe-0 ps-0">Male flower bud2</th>
                        <th scope="col" style="width: 12%" class="pe-0 ps-0">Female flower bud1</th>
                        <th scope="col" style="width: 12%" class="pe-0 ps-0">Female flower bud2</th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,index) in expressionList.slice((currentPage-1)*PageSize,currentPage*PageSize)">
                        <td>{{ (currentPage - 1) * PageSize + index + 1 }}</td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['pk'] }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit;">
                          {{ item['fields'].number_3939_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">
                          {{ item['fields'].number_3940_rsem_genes_results }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_3942_rsem_genes_results
                          }}
                        </td>
                        <td style="word-break:break-all; word-wrap:break-word; white-space:inherit">{{
                            item['fields'].number_3943_rsem_genes_results
                          }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!--    分页操作-->
                    <el-pagination
                        class="el-pager mt-3"
                        style="--el-color-primary:#303034"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="pageSizes"
                        :page-size="PageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="expressionList.length">
                    </el-pagination>
                  </div>
                </div>

              </div>
              <div class="mt-10 py-10 border-t border-blueGray-200 text-center">
                <div class="flex flex-wrap justify-center">
                  <div class="w-full lg:w-9/12 px-4">
                    <p class="mb-4 text-lg leading-relaxed text-blueGray-700">
                      The data in this section are the gene expressions obtained from 10 Lauraceae plants using RSEM software.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component/>
  </div>
</template>
